export default {
  sights: {
    SET_PICTURE: 'SET_PICTURE',
    REMOVE_PICTURE: 'REMOVE_PICTURE',
    SET_CURRENT_SIGHT: 'SET_CURRENT_SIGHT',
    PREVIOUS_SIGHT: 'PREVIOUS_SIGHT',
    NEXT_SIGHT: 'NEXT_SIGHT',
    RESET_TOUR: 'RESET_TOUR',
    ADD_PROCESS_TO_QUEUE: 'ADD_PROCESS_TO_QUEUE',
    REMOVE_PROCESS_FROM_QUEUE: 'REMOVE_PROCESS_FROM_QUEUE',
  },
  additionalPictures: {
    ADD_PICTURE: 'ADD_PICTURE',
    RESET_TOUR: 'RESET_TOUR',
  },
  uploads: {
    UPDATE_UPLOAD: 'UPDATE_UPLOAD',
    RESET_UPLOADS: 'RESET_UPLOADS',
  },
  compliance: {
    UPDATE_COMPLIANCE: 'UPDATE_COMPLIANCE',
    RESET_COMPLIANCE: 'RESET_COMPLIANCE',
  },
  settings: {
    UPDATE_SETTINGS: 'UPDATE_SETTINGS',
    RESET_SETTINGS: 'RESET_SETTINGS',
  },
  customPictureTaking: {
    UPDATE_SETTINGS: 'UPDATE_SETTINGS',
    RESET_SETTINGS: 'RESET_SETTINGS',
  },
};
